import React from "react";
import { Link } from "react-router-dom";
import servicesData from "../data/servicesData";
import useScrollAnimation from "../../hooks/useScrollAnimation";
export default function Services() {
    useScrollAnimation();

    const showData = servicesData.slice(0,3).map((el, index) =>
        <div key={index} className="w-100 js-scroll fade-top bg-white w-[32%] h-[480px] shadow-lg rounded-[8px]">
            <div>
                <img className="w-full h-[250px] object-cover rounded-t-[8px]" src={el.image} alt="" />
            </div>
            <div className="p-[20px] flex flex-col gap-[10px]">
                <div className="font-bold text-[#294a6a] text-[24px]">{el.title}</div>
                <p className="text-[15px]">
                    {el.description}
                </p>
            </div>
        </div>
    )
    return (
        <section className="relative py-[40px]">
            <div className="main-title js-scroll fade-top">
                <div>Our Services</div>
            </div>
            <div className="container f-col py-[20px] flex items-center justify-center gap-[20px] flex-wrap">
                {showData}
                <Link to={"/services"} className="js-scroll fade-btm bg-[#294a6a] text-white py-[6px] px-[20px] rounded-[4px]">Show More</Link>
            </div>
        </section>
    );
}